/* global axios */
import ApiClient from './ApiClient';

class JuyangAiAPI extends ApiClient {
  constructor() {
    super('juyang_ai', { accountScoped: true });
  }

  getSetting() {
    return axios.get(`${this.url}/setting`);
  }

  updateSetting(setting) {
    return axios.patch(`${this.url}/setting`, { setting });
  }

  getAssistants() {
    return axios.get(`${this.url}/assistants`);
  }

  createAssistant(assistant) {
    return axios.post(`${this.url}/assistants`, { assistant });
  }

  updateAssistant(id, assistant) {
    return axios.patch(`${this.url}/assistants/${id}`, { assistant });
  }

  deleteAssistant(id) {
    return axios.delete(`${this.url}/assistants/${id}`);
  }

  playground(id, messageHistory) {
    return axios.post(`${this.url}/assistants/${id}/playground`, {
      assistant: { message_history: messageHistory },
    });
  }

  // 嵌套资源统一通过助手 ID 生成地址，避免各面板重复拼接路径。
  nestedUrl(assistantId, resource) {
    return `${this.url}/assistants/${assistantId}/${resource}`;
  }

  getNested(assistantId, resource) {
    return axios.get(this.nestedUrl(assistantId, resource));
  }

  createNested(assistantId, resource, key, payload) {
    return axios.post(this.nestedUrl(assistantId, resource), {
      [key]: payload,
    });
  }

  updateNested(assistantId, resource, id, key, payload) {
    return axios.patch(`${this.nestedUrl(assistantId, resource)}/${id}`, {
      [key]: payload,
    });
  }

  deleteNested(assistantId, resource, id) {
    return axios.delete(`${this.nestedUrl(assistantId, resource)}/${id}`);
  }

  approveTool(assistantId, toolId) {
    return axios.post(
      `${this.nestedUrl(assistantId, 'tools')}/${toolId}/approve`
    );
  }

  connectInbox(assistantId, inboxId) {
    return axios.post(this.nestedUrl(assistantId, 'inboxes'), {
      inbox_id: inboxId,
    });
  }

  disconnectInbox(assistantId, inboxId) {
    return axios.delete(`${this.nestedUrl(assistantId, 'inboxes')}/${inboxId}`);
  }
}

export default new JuyangAiAPI();
